/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

export class ResizeManager {
  private readonly onResizeEnd: () => void;
  private resizeTimer: Date | null = null;
  private isResizeActive = false;
  private readonly resizeDelay = 500;

  constructor(onResizeEnd: () => void) {
    this.onResizeEnd = onResizeEnd;
  }

  handleResizeStart = (): void => {
    this.resizeTimer = new Date();
    if (!this.isResizeActive) {
      this.isResizeActive = true;
      setTimeout(() => this.checkResizeEnd(), this.resizeDelay);
    }
  };

  private checkResizeEnd = (): void => {
    if (
      this.resizeTimer &&
      new Date().getTime() - this.resizeTimer.getTime() < this.resizeDelay
    ) {
      setTimeout(() => this.checkResizeEnd(), this.resizeDelay);
    } else {
      this.isResizeActive = false;
      this.onResizeEnd();
    }
  };
}
